import React from "react";
import styles from './ComponentSASSLogin.scss';
import TextBox from "../../common/primitives/TextBox";
import {__t} from "../../common/lang/text-resource";
import Button, {buttons} from "../../common/primitives/Button";
import {ContextSASSLoginProvider, useContextSASSLogin} from "../../context/ContextSASSLoginProvider";
import Select from "../../common/primitives/Select";
import FacebookLoginButton from "../../common/primitives/FacebookLoginButton";
import GoogleLoginButton from "../../common/primitives/GoogleLoginButton";
import {ContextSocialLoginProvider} from "../../context/ContextSocialLoginProvider";
import ButtonNew from "../../common/primitives/ButtonNew/ButtonNew";

const ComponentSASSLogin = () => {

	const context = useContextSASSLogin();

	if (context.isLoginDisabled() || context.isForgottenPasswordDisabled()) {
		return <DisabledForRetries/>
	}

	if (context.returnStep() === ContextSASSLoginProvider.SASSLoginStepCheck) {
		return <SASSLoginCheck/>
	}
	if (context.returnStep() === ContextSASSLoginProvider.SASSLoginStepExisting) {
		return <SASSExisting/>
	}
	if (context.returnStep() === ContextSASSLoginProvider.SASSLoginStepNew) {
		return <SASSNew/>
	}

	return <SASSLoginCheck/>
}

const DisabledForRetries = () => {
	return (
	  <div className={styles.disabledContainer}>
		  <strong>{__t('твърде-много-опити-за-достъп-до-клиентския-профил2623b0')}</strong>
		  <br/>
		  <br/>

		  <p>
			  {__t('моля-свържете-се-с-екипа-за-техническа-поддръжка-7f1032')}
			  &nbsp;
			  <a href="/web-hosting-page-contact.php">{__t('на този адрес »')}</a>
		  </p>
	  </div>
	)

}

const SASSLoginCheck = () => {
	const context = useContextSASSLogin();

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			context.submitEmail();
		}
	};

	return (
	  <>
		  <div className={styles.container}>
			  <h2>{__t('Моля, въведете имейл адрес.')}</h2>
			  <div className={styles.inputContainer}>
				  <TextBox
					name={'SASLoginEmail'}
					type={'email'}
					onKeyDown={handleKeyDown}
					value={context.email()}
					placeholder={'mysupersite@gmail.com'}
					onChange={(e) => context.email(e.target.value)}
					error={context.inputError('email')}
				  />
			  </div>
			  <div>
				  {__t('суперхостинг-бг-пази-предоставените-лични-данни-в7284ee')}&nbsp;
				  <a href='/web-hosting-page-terms-and-agreements.php#personal_data' target="_blank"
					 rel='noopener noreferrer'>{__t('Повече')}</a>
			  </div>
			  <div className={styles.buttonContainer}>
				  <ButtonNew
					onClick={context.submitEmail}
					value={__t('Продължи')}
					disabled={context.email() === ''}
				  />

				  <ContextSocialLoginProvider>
					  <div className={styles.mt10}>
						  <FacebookLoginButton/>
					  </div>
					  <div className={styles.mt10}>
						  <GoogleLoginButton/>
					  </div>
				  </ContextSocialLoginProvider>
			  </div>
		  </div>
	  </>
	)
}

const SASSExisting = () => {
	const context = useContextSASSLogin();

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			context.submitPassword();
		}
	};

	return (
	  <>
		  <div className={styles.container}>
			  <h2>{__t('с-този-имейл-адрес-вече-има-създаден-клиентски-прbf6622')}</h2>
			  <div className={styles.inputContainer}>
				  <TextBox
					name={'SASLoginPassword'}
					type={'password'}
					value={context.password()}
					placeholder={'************'}
					onKeyDown={handleKeyDown}
					onChange={(e) => context.password(e.target.value)}
					error={context.inputError('password')}
				  />
			  </div>
			  <SASSFPEmail/>
			  <div className={styles.buttonContainer}>
				  <ButtonNew
					onClick={context.submitPassword}
					value={__t('Продължи')}
				  />
			  </div>
			  <br/>
			  <div>
				  <Button onClick={context.actionBack} value={__t("Обратно")}
						  className={[buttons.buttonLink, buttons.action].join(" ")}/>
			  </div>
		  </div>
	  </>
	)
}

const SASSFPEmail = () => {
	const context = useContextSASSLogin();

	if (context.isFPMailSent()) {
		return (
		  <div>
			  {__t('информацията-за-възобновяване-на-достъпа-до-клиен815abb')}
		  </div>
		)
	}
	return (
	  <div>
		  <Button onClick={context.actionFPEmailSend} value={__t("Забравена парола")}
				  className={[buttons.buttonLink, buttons.action].join(" ")}/>
	  </div>
	)
}

const SASSNew = () => {
	const context = useContextSASSLogin();

	const handleKeyDown = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			context.submitRegister();
		}
	};

	return (
	  <>
		  <div className={styles.containerNew}>
			  <h2>{__t('остават-още-две-стъпки-до-създаването-на-вашия-са4c5c8f')}</h2>
			  <div className={styles.inputContainer}>
				  <div className={styles.row}>
					  <div className={styles.firstCol}>
						  <span>*</span>
					  </div>
					  <div>{__t('Задължителни полета')}</div>
				  </div>
				  <div className={styles.row}>
					  <div className={styles.firstCol}>
						  <span>*</span>
						  <label htmlFor={'SASLoginName'}>{__t('име')}</label>
					  </div>
					  <div>
						  <TextBox
							name={'SASLoginName'}
							type={'text'}
							tabindex={1}
							value={context.name()}
							placeholder={__t('Иван Иванов')}
							onKeyDown={handleKeyDown}
							onChange={(e) => context.name(e.target.value)}
							error={context.inputError('name')}
						  />
					  </div>
				  </div>
				  <div className={styles.row}>
					  <div className={styles.firstCol}>
						  <span>*</span>
						  <label htmlFor={'SASLoginEmail'}>{__t('ел. поща')}</label>
					  </div>
					  <div>
						  <TextBox
							name={'SASLoginEmail'}
							type={'email'}
							tabindex={2}
							value={context.email()}
							disabled={true}
							placeholder={'mysupersite@gmail.com'}
							error={context.inputError('email')}
						  />
					  </div>
				  </div>

				  <div className={styles.row}>
					  <div className={styles.firstCol}>
						  <span>*</span>
						  <label htmlFor={'SASLoginPhone'}>{__t('телефон')}</label>
					  </div>
					  <div className={styles.row}>

						  <div className={styles.phoneCodeContainer}>
							  <Select
								selected={context.phoneCode()}
								name={'SASLoginPhoneCode'}
								options={context.phoneCodes()}
								placeholder={'999'}
								error={context.inputError('SASLoginPhoneCode')}
								required={true}
								isGrouped={true}
								onKeyDown={handleKeyDown}
								onChange={(selectedOption) => context.phoneCode(selectedOption.value)}/>
						  </div>

						  <TextBox
							name={'SASLoginPhone'}
							type={'number'}
							tabindex={3}
							value={context.phone()}
							onChange={(e) => context.phone(e.target.value)}
							placeholder={'99 999 99 99'}
							onKeyDown={handleKeyDown}
							error={context.inputError('phone')}
						  />
					  </div>
				  </div>
				  <div className={styles.row}>
					  <div className={styles.firstCol}>
						  <span>*</span>
						  <label htmlFor={'SASLoginNewPass'}>{__t('парола')}</label>
					  </div>
					  <div>
						  <TextBox
							name={'SASLoginNewPass'}
							type={'password'}
							tabindex={4}
							value={context.password()}
							onChange={(e) => context.password(e.target.value)}
							placeholder={'*********'}
							onKeyDown={handleKeyDown}
							error={context.inputError('password')}
						  />
					  </div>
				  </div>
				  <div className={styles.row}>
					  <div className={styles.firstCol}>
						  <span>*</span>
						  <label htmlFor={'SASLoginPasswordRepeat'}>{__t('повтори')}</label>
					  </div>
					  <div>
						  <TextBox
							name={'SASLoginPasswordRepeat'}
							type={'password'}
							tabindex={5}
							value={context.passwordRepeat()}
							onChange={(e) => context.passwordRepeat(e.target.value)}
							placeholder={'*********'}
							onKeyDown={handleKeyDown}
							error={context.inputError('passwordRepeat')}
						  />
					  </div>
				  </div>

			  </div>
			  <div className={styles.buttonContainer}>
				  <ButtonNew
					onClick={context.submitRegister}
					value={__t('Продължи')}
				  />
			  </div>
		  </div>
	  </>
	)
}

export default ComponentSASSLogin;